<template>

  <b-sidebar
    id="user-edit-profesion-one"
    ref="mysidebar"
    :visible="isEditUserProfesionSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="loadinfo()"
    @change="(val) => $emit('update:is-edit-user-profesion-sidebar-active', val)"
  >

    <b-overlay
      :show="loader.formulario"
      opacity="0.50"
      rounded="sm"
    >
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Editar profesión
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="resetvalues()"
        />

      </div>

      <!--Formulario editar una profesión -->
      <validation-observer ref="simpleRules">
        <b-form class="mt-1">
          <b-row
            class="px-3"
          >
            <!-- Grado -->
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <validation-provider
                #default="{ errors }"
                name="grado"
                rules="required"
              >
                <b-form-group>
                  Último grado de estudios:
                  <v-select
                    v-model="profesionData.id_grado"
                    :options="grados"
                    :reduce="grado => grado.id"
                    label="nombre"
                    filterable
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <!-- Carrera -->
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <b-form-group>
                Carrera:
                <validation-provider
                  #default="{ errors }"
                  name="carrera"
                  rules="min:6|max:255"
                >
                  <b-form-input
                    id="carrera"
                    v-model="profesionData.carrera"
                    :state="errors.length > 0 ? false:null"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <label for="cedula">Cédula</label>
              <validation-provider
                #default="{ errors }"
                name="cedula"
                rules="alpha_num|min:7|max:8"
              >
                <b-form-input
                  id="cedula"
                  v-model="profesionData.cedula"
                  :state="errors.length ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <label for="institucion">Institución educativa donde se obtuvo título/cédula</label>
              <validation-provider
                #default="{ errors }"
                name="Institución Educatica"
                rules="min:1|max:150"
              >
                <b-form-input
                  id="institucion"
                  v-model="profesionData.institucion_educativa"
                  :state="errors.length ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <label for="ef-titulacion">Entidad Federativa de titulación</label>
              <validation-provider
                #default="{ errors }"
                name="ef-titulacion"
              >
                <b-form-group>
                  <v-select
                    id="ef-titulacion"
                    v-model="profesionData.ef_titulacion"
                    placeholder="Seleccione entidad federativa"
                    label="nombre"
                    :reduce="(ef) => ef.id"
                    :options="estados"
                    :clearable="false"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <label for="cct">CCT - Clave de Centro de Trabajo</label>
              <validation-provider
                #default="{ errors }"
                name="cct"
                rules="alpha_num"
              >
                <b-form-input
                  id="cct"
                  v-model="profesionData.cct"
                  :state="errors.length ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>

            </b-col>
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <label for="fecha-ultima-asignatura">Fecha de expedición de la cédula</label>
              <cleave
                id="fecha-ultima-asignatura"
                v-model="profesionData.fecha_para_autoridad_educativa"
                :options="{ date: true, delimiter: '-', datePattern: ['Y', 'm', 'd'] }"
                :raw="false"
                class="form-control"
                placeholder="YYYY-MM-DD"
              />
            </b-col>

            <!-- Puesto -->
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <validation-provider
                #default="{ errors }"
                name="puesto"
                rules="required"
              >
                <b-form-group>
                  Cargo:
                  <v-select
                    v-model="profesionData.id_puesto"
                    :options="puestos"
                    :reduce="puesto => puesto.id"
                    label="nombre"
                    filterable
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <!-- Departamento -->
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <validation-provider
                #default="{ errors }"
                name="departamento"
                rules="required"
              >
                <b-form-group>
                  Adscripción específica:
                  <v-select
                    v-model="profesionData.id_departamento"
                    :options="departamentos"
                    :reduce="departamento => departamento.id"
                    label="nombre"
                    filterable
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <dependenciaform
                :resetea.sync="reseteadeps"
                :inicializadatos="dependenciaini"
                @reseteaemit="reseteadeps=$event"
                @tipodegobierno="idtg=$event"
                @idestado="idef=$event"
                @idmunicipio="idmuni=$event"
                @iddependencia="iddp=$event"
              />

            </b-col>
            >
          </b-row>
          <b-row class=" px-3">
            <b-col>
              <b-button
                variant="primary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                @click.prevent="validationForm()"
              > Guardar
              </b-button>
              <b-button
                variant="outline-secondary"
                @click="resetvalues()"
              > Cancelar
              </b-button>
            </b-col>
          </b-row>
          <b-row
            class=" px-3 mt-1"
          >
            <b-col>
              <b-alert
                variant="primary"
                show
              >
                <div class="alert-body">
                  <span>Los campos de <b>"Dependencia"</b>, <b>"Cargo"</b> y <b>"Área de adscripción específica"</b> son <b>catálogos pre-cargados</b> de nuestra base de datos, <b>si no encuentras lo que buscas,</b> no te preocupes, <b>agrega otra profesión </b>para que puedas dar de alta los nuevos datos. Y si así lo deseas, puedes eliminar el anterior.</span>
                </div>
              </b-alert>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-sidebar>
</template>

<script>
import {
  BRow, BCol, BSidebar, BForm, BButton, BFormGroup, BOverlay, BFormInput, BAlert,
} from 'bootstrap-vue'
import dependenciaform from '@/views/components/dependencias/dependencia.vue'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'

export default {
  components: {
    BForm,
    BFormGroup,
    vSelect,
    BButton,
    BRow,
    BCol,
    BOverlay,
    BFormInput,
    BAlert,
    BSidebar,
    ValidationObserver,
    ValidationProvider,
    Cleave,
    dependenciaform,

  },
  model: {
    prop: 'isEditUserProfesionSidebarActive',
    event: 'update:is-edit-user-profesion-sidebar-active',
  },
  props: {
    isEditUserProfesionSidebarActive: {
      type: Boolean,
      required: true,
    },
    profesionData: {
      type: Object,
      required: true,
    },
    indexProfesion: {
      type: Number,
      required: true,
    },
    idP: {
      type: [String, Number],
      required: true,
    },
    grados: {
      type: Array,
      required: true,
    },
    departamentos: {
      type: Array,
      required: true,
    },
    puestos: {
      type: Array,
      required: true,
    },
    estados: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      dependencias: [],
      dependencia_selected: '',
      // form
      profesionDataForm: {
        type: Object,
      },
      respaldodata: {},
      // EXTRA
      counter: 1,
      loader: {
        formulario: false,
      },
      idtg: null,
      idef: null,
      idmuni: null,
      iddp: null,
      reseteadeps: false,
      dependenciaini: null,
    }
  },
  methods: {
    loadinfo() {
      this.respaldodata = { ...this.profesionData }
      if (!this.respaldodata.tipo_gobierno.id) {
        this.dependenciaini = null
        this.reseteadeps = true
      } else {
        this.dependenciaini = { tipogob: this.respaldodata.tipo_gobierno }
        if (this.respaldodata.tipo_gobierno.id === 1) this.dependenciaini.nivel2 = this.respaldodata.dependencias
        if (this.respaldodata.tipo_gobierno.id === 2) {
          this.dependenciaini.nivel2 = this.respaldodata.entidad_federativa
          this.dependenciaini.nivel3 = this.respaldodata.dependencias
        }
        if (this.respaldodata.tipo_gobierno.id === 3) {
          this.dependenciaini.nivel2 = this.respaldodata.entidad_federativa
          this.dependenciaini.nivel3 = this.respaldodata.municipio
        }
      }
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.counter <= 10) {
            this.counter += 1
            this.submitForm()
          } else {
            this.$bvToast.toast('La página ha expirado, por favor, intente nuevamente más tarde', {
              title: 'Exceso de intentos',
              variant: 'danger',
              solid: true,
            })
          }
        } else {
          this.$bvToast.toast('Selecciona todos los campos obligatorios', {
            title: 'Cuidado',
            variant: 'danger',
            solid: true,
          },
          { timeout: 10000 })
        }
      })
    },
    submitForm() {
      this.reseteadeps = false
      this.loader.formulario = true
      this.profesionDataForm = {}
      this.profesionDataForm.id_persona = this.idP
      this.profesionDataForm.id_profesion = this.profesionData.id_profesion
      this.profesionDataForm.carrera = this.profesionData.carrera
      this.profesionDataForm.id_puesto = this.profesionData.id_puesto
      this.profesionDataForm.id_grado = this.profesionData.id_grado
      this.profesionDataForm.id_departamento = this.profesionData.id_departamento
      this.profesionDataForm.cedula = this.profesionData.cedula
      this.profesionDataForm.institucion_educativa = this.profesionData.institucion_educativa
      this.profesionDataForm.cct = this.profesionData.cct
      this.profesionDataForm.fecha_para_autoridad_educativa = this.profesionData.fecha_para_autoridad_educativa
      this.profesionDataForm.ef_titulacion = this.profesionData.ef_titulacion

      this.$store.dispatch('usuario/postwsperfil', { data: this.profesionDataForm, accion: 3 })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.updateprops(this.profesionData)
          this.modificarDependencia()
        }, error => {
          this.loader.formulario = false
          this.$bvToast.toast(error, {
            title: 'Cuidado',
            variant: 'danger',
            solid: true,
          },
          { timeout: 10000 })
        })
    },
    resetvalues() {
      this.updateprops(this.respaldodata)
      this.updateprops2(this.respaldodata)
      this.$refs.mysidebar.hide()
    },
    updateprops(valor) {
      const p = this.puestos.find(puesto => puesto.id === valor.id_puesto)
      const g = this.grados.find(grado => grado.id === valor.id_grado)
      const d = this.departamentos.find(depa => depa.id === valor.id_departamento)
      this.profesionData.puesto = p.nombre
      this.profesionData.grado = g.nombre
      this.profesionData.acronimo = g.acronimo
      this.profesionData.nivelAcademico = g.nivel_academico
      this.profesionData.departamento = d.nombre
    },
    updateprops2(valor) {
      // para reset
      this.profesionData.id_persona = valor.idP
      this.profesionData.id_profesion = valor.id_profesion
      this.profesionData.carrera = valor.carrera
      this.profesionData.id_puesto = valor.id_puesto
      this.profesionData.id_grado = valor.id_grado
      this.profesionData.id_departamento = valor.id_departamento
      this.profesionData.cedula = valor.cedula
      this.profesionData.institucion_educativa = valor.institucion_educativa
      this.profesionData.cct = valor.cct
      this.profesionData.fecha_para_autoridad_educativa = valor.fecha_para_autoridad_educativa
      this.profesionData.ef_titulacion = valor.ef_titulacion
    },
    modificarDependencia() {
      this.loader.formulario = true
      this.profesionDataForm = {
        tipo_gob: this.idtg,
        municipio: this.idmuni,
        dependencia: this.iddp,
        id_profesion: this.profesionData.id_profesion,
        id_prof_dep: this.profesionData.id_prof_dep,
      }
      this.$store.dispatch('usuario/postwsperfil', { data: this.profesionDataForm, accion: 13 })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.profesionData.dependencias = this.iddp
          this.profesionData.tipo_gobierno = this.idtg
          this.profesionData.municipio = this.idmuni
          this.profesionData.entidad_federativa = this.idef

          this.registroExitoso()
        }, error => {
          this.loader.formulario = false
          this.$bvToast.toast(error, {
            title: 'Cuidado',
            variant: 'danger',
            solid: true,
          },
          { timeout: 10000 })
        })
    },
    registroExitoso() {
      this.loader.formulario = false
      this.$swal({
        title: '<b>Registro modificado</b>',
        html: '',
        icon: 'success',
        timer: 10000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
  },
}
</script>

<style lang="scss">

@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
